const getBaseUrl = () => {
  if (window?.location?.origin) {
    var base_url = window.location.origin;

    var apiUrl = `${base_url}/home2026-api`;
    return apiUrl;
  } else {
    return "";
  }
};

const getBaseUrlMedia = () => {
  if (window?.location?.origin) {
    var base_url = window.location.origin;

    var apiUrl = `${base_url}/home2026-api/public/uploads`;
    return apiUrl;
  } else {
    return "";
  }
};

const getBaseUrlRoot = () => {
  if (window?.location?.origin) {
    var base_url = window.location.origin;
    var apiUrl = `${base_url}/home2026-fe`;
    return apiUrl;
  } else {
    return "";
  }
};

// const CONFIG = {
//   URL: getBaseUrl(),
//   URL_MEDIA: getBaseUrlMedia(),
//   URL_ROOT: getBaseUrlRoot(),
// };

const CONFIG = {
  URL: "https://home2026-api.event-ku.com",
  URL_MEDIA: "https://home2026-api.event-ku.com/public/uploads/",
  URL_ROOT: "https://home2026.event-ku.com",
};

export default CONFIG;
